import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { fetchCostCenters } from '~actions/rootActions';

// Cost centers are _not_ fetched before they're needed!
// Since the data can be many megabytes, we also want to save the result
// into Redux so we won't need to fetch it again
const useCostCenterOptions = ({ useId, formatLabel } = {}) => {
  const dispatch = useDispatch();
  const costCenters = useSelector(state => state.reducer.costCenters);

  useEffect(() => {
    if (costCenters) return; // Skip fetching if we've already done it
    dispatch(fetchCostCenters());
  }, [costCenters]);

  const costCenterOptions = costCenters?.map(costCenter => ({
    // Our system has its own id, but cost centers have their own codes as well
    value: useId ? costCenter.id : costCenter.costCentre,
    label:
      (formatLabel && formatLabel(costCenter)) ||
      costCenter.costCentreTitle ||
      costCenter.costCentre,
  }));

  return costCenterOptions || []; // The redux state could be null
};

export default useCostCenterOptions;
